export default __webpack_public_path__ + "static/media/favorite-24px.8a6e6069.svg";